import React from 'react';

import { useDelayedUnmount } from 'hooks/use-delayed-unmount';

import { DrawerContainer, NAVIGATION_DRAWER_ANIMATION_TIME } from './navigation-drawer.styled';

interface INavigationDrawerProps {
  mainView: React.ReactNode;
  sideView: React.ReactNode;
  isSideViewActive: boolean;
}

export const NavigationDrawer: React.FC<INavigationDrawerProps> = ({
  mainView,
  sideView,
  isSideViewActive,
}) => {
  const isVisible = useDelayedUnmount(isSideViewActive, NAVIGATION_DRAWER_ANIMATION_TIME);

  return (
    <DrawerContainer $isSideViewActive={isSideViewActive}>
      <div className="drawer-main-panel">{mainView}</div>
      <div className="drawer-side-panel">{isVisible && sideView}</div>
    </DrawerContainer>
  );
};
